var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXWhite81(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "url(#pattern0_35_124)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_35_124",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_35_124",
    transform: "matrix(0.0137061 0 0 0.0131579 -0.00712719 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_35_124",
    width: 74,
    height: 76,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABMCAMAAAD9V9FeAAAAM1BMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADbQS4qAAAAEHRSTlMAwOCg0DBAEPCAkFBwILBgaE6PuQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAsxJREFUWIWdWNuWhCAMG+8i6vj/X7tnpUpJS4HJoyvY0CR05zM7DcunFj6s/l+wrJeCrXanb1gb3vdyo+u6ZrFIxRQKGehvp9jnuq6+iiJRGp+Xl15sxD5kYRnxs3NY3D0IL3hjj4TPOrFH2/1of8u+y1yLFAflWIniu3so8xRrU1DzvunTsHbMlanCcxkwuPuxe8u8j2s9tC0IIAOGMaU4hUaI1+KZgAz4R6CtUKbYSchAUIzMoUzAIGUgKL6dPda0Ewk2RQYMYW1U056nqMuAYQc1dbkvzxkZMHSpYUKZ8mTzMshT9OrHyRqaDBi+oKZT87UlA4YTfA1lfooyYMWvqWGkr50tAwav+jp2vSgDQTH6uk/KnMoyYBTV6KJO1MiAAaPLxU6QhwsyYNg0X98d6+pkICi+PZqeMmtlICj26Ou9WgYMDg43EGuQAQNchEccK6pniQfheDC6GmTA4MAwNFbUy4ChSw+G7hfrMsviAF8Hb5buax07RNegRVcTxeaRRANR1H3dCD267JEkB4yu8kiSBSkARpLMfV2AB18XRhITgxZd2ZHEhIdcoZHkB0VQlIvoao4HNs9XjCQm6FLQoqsh3m+EMx8huvwPueXoUnBgGHUkMUE3+vQowBxJTEzxUqB0NkYSEySDIGyMriZfU/Oew+3A1+lIYmNMjXuArxuia8DrZYdMcLUUHxmwR4Fis6+jDCIouuRIYoKaB7MBRpfxr8aLY9VfOiETyr4GGQiKDb7usofgwdel6BIyYNjAMLavdykDRrFP+2H62isyYJjB18ZIostAUKwYSZaMDNgbGF0ZX2dlwOuGs8z4+szKgMHBS2p0WTJgGCG6xku0/GvJQFC0RpLZlgHDDr7GkaQoA4ZgrWF+kCYs6diQAcOh/mJJZdbIQFBEBF9T8yp3Sv97iviPrqCNhqFJ/1G2X54cahnltB9lr2v4Awh6V+l7nLYxAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWhite81);
export default __webpack_public_path__ + "static/media/x_white-8 1.506e823721d64bcfd6f8d62d25a59f8a.svg";
export { ForwardRef as ReactComponent };